import React from 'react';
import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import EyeIcon from '../ui/icons/eye';
import { useAccessibility } from '../../contexts/AccessibilityContext';
import styles from './AccessibilityButton.module.scss';

interface AccessibilityButtonProps {
    className?: string;
}

const AccessibilityButton: React.FC<AccessibilityButtonProps> = ({
    className,
}) => {
    const { t } = useTranslation();
    const { showToolbar } = useAccessibility();

    const classes = [styles.accessibilityButton, className]
        .filter(Boolean)
        .join(' ');

    return (
        <Button
            type="text"
            icon={<EyeIcon width={24} height={24} />}
            onClick={showToolbar}
            className={classes}
            aria-label={t('buttons.accessibility')}
        >
            {t('buttons.accessibility')}
        </Button>
    );
};

export default AccessibilityButton;
